module.exports = __webpack_public_path__ + "static/media/atmDispute.c338873d.svg";